import script from "./DeptManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeptManager.vue?vue&type=script&setup=true&lang=ts"

import "./DeptManager.vue?vue&type=style&index=0&id=0adf2556&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0adf2556"]])

export default __exports__